<template>
    <BaseCRUDPageLayout :links="links">
      <template v-slot:tableName>الأسئلة الشائعة</template>
      <template v-slot:tableActions>
        <CreateFAQButton />
        <FAQsFilter class="mr-5" />
      </template>
      <template v-slot:dataTable>
        <FAQsTable />
      </template>
    </BaseCRUDPageLayout>
  </template>
  
  <script>
  import FAQsTable from "../components/FAQsTable.vue";
  import FAQsFilter from "../components/FAQsFilter.vue";
  import CreateFAQButton from "../components/action_buttons/CreateFAQButton.vue";

  export default {
    data() {
      return {
        links: [
          {
            text: "الصفحة الرئيسية",
            href: "/",
            disabled: false,
          },
          {
            text: "الأسئلة الشائعة",
            disabled: true,
          },
        ],
      };
    },
    components: { FAQsTable, FAQsFilter, CreateFAQButton },
  };
  </script>
  